import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";

import PropTypes from "prop-types";

const DeleteAssetModal = (props) => {
  const {
    message,
    onConfirm,
    onExit,
    open,
  } = props;
  return (
    <Modal
      opened={open}
      disableOutsideClick={true}
      ariaLabel={`title Modal`}
      surface="light"
      fullScreenDialog={false}
      hideCloseButton={true}
      disableAnimation={false}
      onClose={onExit}
      width={"700px"}
      closeButton={
        <button
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
            backgroundColor: "transparent",
            border: "none",
          }}
          onClick={onExit}
        >
          <Icon name="close" />
        </button>
      }
      {...props}
    >
      <ModalTitle>
        <Title size="large" bold={true}>Delete asset</Title>
      </ModalTitle>
      <ModalBody>
        <Body size="large">
          { <span>Are you sure you want to delete the asset <span className="ats-bold">{message}?</span> <br/> Deleting the asset, will permanently remove the data of the asset.</span>}
        </Body>
      </ModalBody>
      <ModalFooter
        buttonData={{
          close: {
            width: "100%",
            children: "Yes, delete",
            onClick: onConfirm,
          },
          primary: {
            children: "No, cancel",
            width: "100%",
            onClick: onExit,
          },
        }}
      />
    </Modal>
  );
};

DeleteAssetModal.propTypes = {
  message: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired
}

export default DeleteAssetModal;
